import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import RequestDefinition from '../RequestDefinition';

import {importExportHeader} from '../../data/importExport/importExport';

export default new RouteComponent(`${apiRoutePrefix}/import`, () => {
    return (
        <div>
            <ObjectHeader data={ importExportHeader }/>
            {
                importExportHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
